export default __webpack_public_path__ + "static/media/3k-unachieved.39750347.svg";